<template>
    <div
        :class="[
            'sub-status-card',
        ]"
    >
        <div class="not-pro-status" v-if="!person?.license" >
            <svg class="w-4 h-4 fill-zinc-600" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1.5V5C12 6.5775 11.6344 7.8575 11.1062 8.88375C11.0879 8.91986 11.061 8.95095 11.0279 8.97436C10.9949 8.99777 10.9566 9.0128 10.9165 9.01815C10.8763 9.0235 10.8355 9.01901 10.7974 9.00507C10.7594 8.99113 10.7253 8.96816 10.6981 8.93813L3.4075 0.918128C3.37479 0.882132 3.35328 0.837374 3.34563 0.789339C3.33797 0.741305 3.3445 0.69208 3.3644 0.647698C3.3843 0.603315 3.41672 0.565702 3.45768 0.539469C3.49864 0.513235 3.54636 0.49952 3.595 0.500003H11C11.2652 0.500003 11.5196 0.60536 11.7071 0.792897C11.8946 0.980433 12 1.23479 12 1.5ZM1.37 0.163753C1.29481 0.0812955 1.1942 0.0263608 1.08418 0.00769415C0.974157 -0.0109725 0.861055 0.00770196 0.762875 0.0607449C0.664695 0.113788 0.587082 0.19815 0.54239 0.300402C0.497698 0.402654 0.488496 0.516918 0.51625 0.625003C0.359879 0.711434 0.22952 0.83818 0.138731 0.992061C0.0479412 1.14594 3.68479e-05 1.32134 0 1.5V5C0 8.295 1.595 10.2919 2.93313 11.3869C4.37437 12.5656 5.80813 12.9663 5.87063 12.9825C5.95656 13.0059 6.04719 13.0059 6.13313 12.9825C6.19563 12.9663 7.6275 12.5656 9.07063 11.3869C9.28975 11.2064 9.4994 11.0146 9.69875 10.8125L10.63 11.8363C10.6739 11.8857 10.7272 11.926 10.7868 11.9548C10.8464 11.9835 10.9111 12.0002 10.9772 12.0037C11.0432 12.0073 11.1094 11.9977 11.1717 11.9755C11.234 11.9533 11.2913 11.919 11.3403 11.8745C11.3893 11.83 11.4289 11.7762 11.4569 11.7163C11.485 11.6563 11.5008 11.5914 11.5036 11.5253C11.5064 11.4592 11.496 11.3932 11.473 11.3311C11.4501 11.2691 11.4151 11.2122 11.37 11.1638L1.37 0.163753Z" fill="#52525C"/>
            </svg>
            <p>Unlicensed</p>

            <div class="flex-1"></div>

            <p class="upgrade-text" @click="onUnlicensedUpgrade">
                Upgrade
                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.8538 5.35375L7.35375 9.85375C7.25993 9.94757 7.13268 10.0003 7 10.0003C6.86732 10.0003 6.74007 9.94757 6.64625 9.85375C6.55243 9.75993 6.49972 9.63269 6.49972 9.5C6.49972 9.36732 6.55243 9.24007 6.64625 9.14625L10.2931 5.5H0.5C0.367392 5.5 0.240215 5.44733 0.146447 5.35356C0.0526785 5.25979 0 5.13261 0 5C0 4.86739 0.0526785 4.74022 0.146447 4.64645C0.240215 4.55268 0.367392 4.5 0.5 4.5H10.2931L6.64625 0.853753C6.55243 0.759933 6.49972 0.632685 6.49972 0.500003C6.49972 0.367321 6.55243 0.240074 6.64625 0.146253C6.74007 0.052433 6.86732 -0.000274658 7 -0.000274658C7.13268 -0.000274658 7.25993 0.052433 7.35375 0.146253L11.8538 4.64625C11.9002 4.69269 11.9371 4.74783 11.9623 4.80853C11.9874 4.86923 12.0004 4.9343 12.0004 5C12.0004 5.06571 11.9874 5.13077 11.9623 5.19147C11.9371 5.25217 11.9002 5.30732 11.8538 5.35375Z" fill="#F6BB1E"/>
                </svg>
            </p>
        </div>

        <div class="pro-status" v-else @click="handleLicenseClick">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
                <path
                    d="M13 2.5H3C2.73478 2.5 2.48043 2.60536 2.29289 2.79289C2.10536 2.98043 2 3.23478 2 3.5V7C2 10.295 3.595 12.2919 4.93313 13.3869C6.37437 14.5656 7.80813 14.9656 7.87063 14.9825C7.95656 15.0059 8.04719 15.0059 8.13313 14.9825C8.19563 14.9656 9.6275 14.5656 11.0706 13.3869C12.405 12.2919 14 10.295 14 7V3.5C14 3.23478 13.8946 2.98043 13.7071 2.79289C13.5196 2.60536 13.2652 2.5 13 2.5ZM10.855 6.85375L7.355 10.3538C7.30856 10.4002 7.25342 10.4371 7.19272 10.4623C7.13202 10.4874 7.06696 10.5004 7.00125 10.5004C6.93554 10.5004 6.87048 10.4874 6.80978 10.4623C6.74908 10.4371 6.69394 10.4002 6.6475 10.3538L5.1475 8.85375C5.05368 8.75993 5.00097 8.63268 5.00097 8.5C5.00097 8.36732 5.05368 8.24007 5.1475 8.14625C5.24132 8.05243 5.36857 7.99972 5.50125 7.99972C5.63393 7.99972 5.76118 8.05243 5.855 8.14625L7 9.29313L10.1462 6.14625C10.1927 6.09979 10.2479 6.06294 10.3086 6.0378C10.3692 6.01266 10.4343 5.99972 10.5 5.99972C10.5657 5.99972 10.6308 6.01266 10.6914 6.0378C10.7521 6.06294 10.8073 6.09979 10.8538 6.14625C10.9002 6.1927 10.9371 6.24786 10.9622 6.30855C10.9873 6.36925 11.0003 6.4343 11.0003 6.5C11.0003 6.5657 10.9873 6.63075 10.9622 6.69145C10.9371 6.75214 10.9002 6.8073 10.8538 6.85375H10.855Z"
                    fill="#F6BB1E" />
            </svg>
            <p>{{ person?.license?.type }} License</p>
        </div>

        <div class="divider"></div>

        <div class="status-wrapper">            
            <div class="sub-status-item">
                <CheckIcon v-if="person?.license" class="check-icon" />
                <svg v-else width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8 10.7556L8.33437 1.26375C8.19779 1.0312 8.00281 0.838382 7.76875 0.704408C7.53469 0.570434 7.26969 0.499954 7 0.499954C6.73031 0.499954 6.4653 0.570434 6.23124 0.704408C5.99719 0.838382 5.8022 1.0312 5.66562 1.26375L0.199999 10.7556C0.0685841 10.9805 -0.000671387 11.2364 -0.000671387 11.4969C-0.000671387 11.7574 0.0685841 12.0132 0.199999 12.2381C0.334831 12.4721 0.52948 12.6659 0.763975 12.7998C0.998469 12.9337 1.26436 13.0028 1.53437 13H12.4656C12.7354 13.0026 13.0011 12.9334 13.2353 12.7995C13.4696 12.6656 13.664 12.4719 13.7987 12.2381C13.9304 12.0133 13.9998 11.7575 14 11.497C14.0003 11.2365 13.9312 10.9807 13.8 10.7556ZM12.9331 11.7375C12.8855 11.8188 12.8171 11.8859 12.7349 11.932C12.6528 11.9782 12.5598 12.0016 12.4656 12H1.53437C1.44017 12.0016 1.34723 11.9782 1.26508 11.932C1.18293 11.8859 1.11452 11.8188 1.06687 11.7375C1.02371 11.6644 1.00095 11.5811 1.00095 11.4962C1.00095 11.4114 1.02371 11.3281 1.06687 11.255L6.5325 1.76312C6.58111 1.68223 6.64983 1.61529 6.73197 1.56882C6.81411 1.52235 6.90688 1.49793 7.00125 1.49793C7.09562 1.49793 7.18839 1.52235 7.27053 1.56882C7.35267 1.61529 7.42139 1.68223 7.47 1.76312L12.9356 11.255C12.9784 11.3283 13.0007 11.4117 13.0003 11.4966C12.9999 11.5815 12.9767 11.6646 12.9331 11.7375ZM6.5 8V5.5C6.5 5.36739 6.55268 5.24021 6.64645 5.14644C6.74021 5.05267 6.86739 5 7 5C7.13261 5 7.25978 5.05267 7.35355 5.14644C7.44732 5.24021 7.5 5.36739 7.5 5.5V8C7.5 8.1326 7.44732 8.25978 7.35355 8.35355C7.25978 8.44732 7.13261 8.5 7 8.5C6.86739 8.5 6.74021 8.44732 6.64645 8.35355C6.55268 8.25978 6.5 8.1326 6.5 8ZM7.75 10.25C7.75 10.3983 7.70601 10.5433 7.6236 10.6667C7.54119 10.79 7.42406 10.8861 7.28701 10.9429C7.14997 10.9997 6.99917 11.0145 6.85368 10.9856C6.7082 10.9566 6.57456 10.8852 6.46967 10.7803C6.36478 10.6754 6.29335 10.5418 6.26441 10.3963C6.23547 10.2508 6.25032 10.1 6.30709 9.96298C6.36385 9.82594 6.45998 9.7088 6.58332 9.62639C6.70666 9.54398 6.85166 9.5 7 9.5C7.19891 9.5 7.38968 9.57901 7.53033 9.71967C7.67098 9.86032 7.75 10.0511 7.75 10.25Z" fill="#E74341"/>
                </svg>
                <p v-if="person?.license"><span>Active </span>Protection</p>
                <p v-else><span>Unprotected & Vulnerable</span></p>
            </div>

            <div class="sub-status-item">
                <CheckIcon v-if="person?.license" class="check-icon" />
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-zinc-600" viewBox="0 0 256 256">
                    <path
                        d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z">
                    </path>
                </svg>
                <p><span>{{ formatNumber(statsData?.data_brokers) }} </span> Data Brokers</p>
            </div>

            <div class="sub-status-item">
                <CheckIcon v-if="authStore.user?.license" class="check-icon" />
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-zinc-600" viewBox="0 0 256 256">
                    <path
                        d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z">
                    </path>
                </svg>
                <p><span>{{ formatNumber(statsData?.custom_sites) }}</span> Custom Sites</p>
            </div>

            <div class="sub-status-item">
                <CheckIcon v-if="person?.license" class="check-icon" />
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-zinc-600" viewBox="0 0 256 256">
                    <path
                        d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z">
                    </path>
                </svg>
                <p><span>{{ formatTimeFromMinutes(authStore.user?.stats?.time_saved) }}</span> Time Saved</p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import { CheckIcon } from '@heroicons/vue/24/outline';
import { PurchaseType } from '~/types/licenses/licenses';


const authStore = useAuthStore();
const store = usePersonStore();
const { formatNumber, formatTimeFromMinutes } = useUtils();
const { openPurchaseModal, purchaseForCurrentPerson } = useLicensePurchase();

const { person } = storeToRefs(store);
const globalStore = useGlobalStore();
const { statsData } = storeToRefs(globalStore);

// Check if license is signature
const isSignatureLicense = computed(() => {
    return person.value?.license?.type?.toLowerCase() === 'signature';
});

// Check if user can upgrade license (owns the license)
const canUpgradeLicense = computed(() => {
    const license = person.value?.license;
    const personId = person.value?.id;
    
    return !isSignatureLicense.value && 
           license?.owner?.type === 1 && 
           license?.owner?.id === personId;
});

function onUnlicensedUpgrade() {
    // Buy a license for whoever is currently on screen. purchaseForCurrentPerson applies the
    // employer purchase-restriction guard and carries the managed/impersonated person as the
    // beneficiary, instead of a raw checkout redirect that bypassed both.
    purchaseForCurrentPerson();
}

// Only the owner of a non-signature license can modify it, so gate the badge's upgrade redirect
// on canUpgradeLicense — signature and non-owned licenses are not sent into the modify flow.
// Routing through openPurchaseModal also applies the employer purchase-restriction guard.
const handleLicenseClick = () => {
    if (!canUpgradeLicense.value) return;
    const currentLicense = person.value?.license;
    if (!currentLicense?.id) return;
    openPurchaseModal({ type: PurchaseType.UPGRADE, license: currentLicense });
};
</script>

<style lang="scss" scoped>
.sub-status-card {
    @apply mx-4 p-4 rounded-md bg-zinc-900 relative;

    .not-pro-status {
        @apply flex items-center gap-2 pb-3;

        p {
            @apply font-semibold text-sm text-white cursor-default;
        }

        .upgrade-text {
            @apply text-amber-400 text-right font-semibold text-sm cursor-pointer flex gap-1 items-center hover:underline;
            svg {
                @apply hidden;
            }
            &:hover svg {
                @apply block;
            }
        }
    }
    .divider {
        @apply bg-zinc-800 h-px mb-3 w-full;
    }

    .pro-status {
        @apply flex pb-3 items-center gap-2 self-stretch;

        p {
            @apply text-white cursor-default;
        }
    }

    .sub-status-item {
        @apply flex items-center gap-2;

        p {
            @apply text-white cursor-default;

            span {
                @apply text-white font-medium cursor-default; 
            }
        }
    }
}
.status-wrapper {
    @apply gap-2 flex flex-col;
}

.check-icon {
    @apply h-6 w-6 text-amber-400;
}
.upgrade-btn {
  @apply relative z-10 mt-6 w-full bg-zinc-800 bg-origin-border;
}

.upgrade-btn:hover {
  @apply bg-zinc-700 text-amber-400;
}

.upgrade-btn::before {
  @apply content-[''] absolute inset-0 p-px -z-[1] pointer-events-none;
  background: linear-gradient( 180deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%  );
  -webkit-mask: linear-gradient(#fff 0 0) content-box,  linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
}

.upgrade-text:hover{
    @apply cursor-default;

    svg{
        @apply block;
    }
}
</style>
